import styled, { css } from 'styled-components';
import _ from 'lodash';
import Text from 'components/Text';
import Icon from 'components/Icon';
import Button from 'components/Button';
import { colorVariables } from 'theme/variables';

export const SettingsListStyled = styled.div`
  position: static;
`;

export const SettingsLineStyled = styled.div`
  position: static;
`;

export const SettingsLineSubscriptionStyled = styled.div`
  position: static;
  display: flex;
  justify-content: center;
  padding: 0 25px;
`;

export const ListInner = styled.div`
  position: absolute;
  min-width: 270px;
  left: -2px;
  transform: translateX(-100%);
  background-color: ${colorVariables.gray_cod};
  padding: 15px 0;
  margin: 0;
  list-style-type: none;
  overflow: auto;
  border-radius: 10px;

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    width: 3px;
    height: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgb(75, 75, 75);
  }
  
  scrollbar-width: thin;
  scrollbar-color: rgb(75, 75, 75) transparent;

  ${(props) => css`
    top: ${props.top}px;
    display: ${props.visible ? 'initial' : 'none'};
  `};

  ${(props) =>
    props.maxHeight
      ? css`
          max-height: ${props.maxHeight}px;
        `
      : undefined};
}
`;

// quick and dirty, lazy solution, I'm sorry
export const ListInnerLastOne = styled(ListInner)`
  bottom: 0;
  top: unset;
`;

export const StyledTextLabel = styled(Text)`
  font-family: inherit;
  margin-right: 8px;
  color: ${(props) => _.get(colorVariables, props.theme.main_default)};
  };
`;

export const StyledButton = styled(Button)`
  && {
    width: 100%;
    height: 100%;
    padding-left: 15px;
  }
`;

export const StyledItemText = styled(Text)`
  font-family: inherit;
  white-space: nowrap;
  color: ${(props) =>
    props.value === props.current
      ? _.get(colorVariables, props.theme.main)
      : props.theme.main_default};
  };
`;

export const StylesItemExtraLabel = styled(Text)`
  color: rgba(255, 255, 255, 0.5);
  flex-basis: 100%;
`;

/**
 * set visibility to hidden for, and only for element where `checked` **explicit** `false`,
 * and keep visible for any other case, include `undefined`
 *
 * @typedef {import("styled-components").StyledComponent} StyledComponent
 * @type {StyledComponent<React.NamedExoticComponent<{readonly fillColor?: *, readonly width?: *, readonly className?: *, readonly height?: *, readonly name?: *, readonly viewBox?: *, readonly size?: *, readonly strokeColor?: *}>, AnyIfEmpty<DefaultTheme>, {}, never>}
 */
export const StyledItemIcon = styled(Icon)`
  fill: ${(props) =>
    props.value === props.current
      ? _.get(colorVariables, props.theme.main)
      : 'white'};
  visibility: ${({ checked }) => (checked === false ? 'hidden' : 'visible')};
  transition: none;
`;

export const ItemButton = styled.div`
  display: flex;
  align-items: center;
  position: static;
  width: 100%;
  height: 34px;
  text-align: left;
  padding: 0 25px;
  border: none;
  cursor: pointer;
  flex-grow: 1;
  ${(props) =>
    props.open &&
    css`
      background: transparent;
      &:after {
        content: '';
        position: absolute;
        left: -3px;
        right: 0;
        border: 7px solid transparent;
        border-left-color: ${colorVariables.gray_cod};
      }
    `};

  &:hover {
    ${StyledItemIcon} {
      fill: ${(props) => _.get(colorVariables, props.theme.main_hover_color)};
    }
    ${StyledItemText} {
      color: ${(props) => _.get(colorVariables, props.theme.main_hover_color)};
    }
  }
`;
export const CheckboxItem = styled.label`
  display: flex;
  align-items: center;
  width: 100%;
  height: 34px;
  text-align: left;
  padding: 0 25px;
  border: none;
  flex-grow: 1;
  flex-wrap: wrap;
  cursor: pointer;

  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: auto;
      ${StyledItemText} {
        color: rgba(255, 255, 255, 0.3);
      }
    `};

  ${(props) => css`
    ${props.decoration}
  `};

  &:hover * {
    color: ${(props) => _.get(colorVariables, props.theme.main_hover_color)};
    fill: ${(props) => _.get(colorVariables, props.theme.main_hover_color)};
  }

  & input {
    display: none;
  }
`;

export const ItemButtonInner = styled.div`
  display: flex;
  align-items: center;
  position: static;
  width: 100%;
  height: 34px;
  text-align: left;
  padding: 0 25px;
  border: none;
  cursor: pointer;
  flex-grow: 1;
  flex-wrap: wrap;

  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: auto;
      ${StyledItemText} {
        color: rgba(255, 255, 255, 0.3);
      }
    `};

  ${(props) => css`
    ${props.decoration}
  `};

  &:hover {
    ${StyledItemIcon} {
      fill: ${(props) => _.get(colorVariables, props.theme.main_hover_color)};
    }
    ${StyledItemText} {
      color: ${(props) => _.get(colorVariables, props.theme.main_hover_color)};
    }
  }
`;

export const BySubscriptionButton = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: inherit;
  cursor: pointer;
  border: ${(props) => `solid 1px ${_.get(colorVariables, props.theme.main)}`};
  border-radius: 4px;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
  height: 37px;
  transition: all 0.25s ease;
  &:hover {
    border-color: ${(props) =>
      _.get(colorVariables, props.theme.main_hover_color)};
    ${StyledItemText} {
      color: ${(props) => _.get(colorVariables, props.theme.main_hover_color)};
    }
  }
`;
